import layout from './layouts/Main.vue'
import GlobalMixin from '@/app/shared/mixins/global';
import BaseGestaoMixin from '@/app/shared/mixins/BaseGestaoMixin';
import ModuleMixin from './shared/mixins/ModuleMixin';

export default {
    mixins: [
        GlobalMixin,
        BaseGestaoMixin,
        ModuleMixin,
    ],
	components: {
	    layout: layout,
	},
    data() {
        return {
            pageID: null,
        }
    },
    mounted() {

    },
    computed: {
    },
    methods: {
    },
}